import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function PainPointsSection() {
  return <section className="py-20 bg-[#0A0A0A] relative border-t border-gray-900" data-id="element-140">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto bg-gray-900/50 rounded-3xl p-8 md:p-12 border-l-4 border-[#22C55E] relative overflow-hidden" data-id="element-142">
          {/* Background pattern */}
          <div className="absolute top-0 right-0 p-8 opacity-5" data-id="element-143">
            <AlertTriangle className="w-64 h-64 text-white" data-id="element-144" />
          </div>

          <div className="relative z-10" data-id="element-145">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-146">
              ¿Cansado de las dietas que prometen{' '}
              <span className="text-[#F59E0B]" data-id="element-147">resultados milagrosos?</span>
            </h2>

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-148">
              Las dietas extremas terminan en rebote.{' '}
              <span className="text-white font-semibold" data-id="element-149">
                Este ebook es diferente:
              </span>{' '}
              te guía a través de micro-hábitos prácticos que puedes incorporar
              en tu rutina diaria para una transformación real y sostenible.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}